/**
 * Handler du bouton « Précédent » de ValidateSlideButtons : identique sur desktop,
 * mobile hors widget et widget (la flèche du header mobile n'existe plus côté DS).
 */
export const getPrevHandler = (canPrev: boolean, goPrev: () => void): (() => void) | undefined =>
  canPrev ? goPrev : undefined
